import script from "./EditInvoiceDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditInvoiceDialog.vue?vue&type=script&setup=true&lang=js"

import "./EditInvoiceDialog.vue?vue&type=style&index=0&id=5d777f03&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d777f03"]])

export default __exports__